(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationDiet', EvaluationDiet);

    EvaluationDiet.$inject = ['$resource'];

    function EvaluationDiet ($resource) {
        var resourceUrl =  'api/evaluation-diets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-diets/by-evaluation/:id', isArray: true}
        });
    }
})();
